import { useEffect } from "react";
import AboutCompanySection from "../sections/AboutCompanySection";
import AboutCompanyTwoSection from "../sections/AboutCompanyTwoSection";
import CompanyPartnersSection from "../sections/CompanyPartnersSection";
import ServicesSection from "../sections/ServicesSection";
import ApplicationFormSection from "../sections/ApplicationFormSection";

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="w-full">
      <AboutCompanySection />
      <AboutCompanyTwoSection />
      <CompanyPartnersSection />
      <ServicesSection />
      <ApplicationFormSection />
    </div>
  );
};

export default AboutPage;

